import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import Jumbotron from './Jumbotron';
import Services from './Services';
import Company from './Company';

const styles = theme => ({
  root: {
  },
});

class Home extends Component {
  render() {
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        <Jumbotron />
        <Services />
        <Company />
      </div>
    );
  }
};

Home.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Home);



// WEBPACK FOOTER //
// ./src/components/index/Home.js